import { initializeFeatureFlags } from 'owa-feature-flags';
import { orchestrator, action } from 'satcheljs';

let areFlagsInitialized = false;
let resolveWhenFlagsInitialized = null;
// tslint:disable-next-line:promise-must-complete
export const waitForFlagsInitialization = new Promise(resolve => {
    // Promises are eagerly evaluated, so `resolveWhenFlagsInitialized`
    // should be initialed in the initial module pass
    // by this promise
    if (areFlagsInitialized) {
        resolve();
    } else {
        resolveWhenFlagsInitialized = resolve;
    }
});

orchestrator(initializeFeatureFlags, () => {
    waitForAfterFlags();
});

// Defer evaluation of resolving the feature flag until after
// the flags mutator has executed by firing a new action to the action queue
// and listening to it with an orchestrator.
//
// See https://github.com/microsoft/satcheljs/issues/120
const waitForAfterFlags = action('waitForAfterFlags', () => ({}));
orchestrator(waitForAfterFlags, () => {
    // resolve the promise at most once.
    if (!areFlagsInitialized) {
        areFlagsInitialized = true;
        if (resolveWhenFlagsInitialized) {
            resolveWhenFlagsInitialized();
        }
    }
});
